import React from 'react';
import "../GuidedExperience/GuidedExperienceWizard.css";
import { useTranslation } from 'react-i18next';
import AIRPNumberInput from '../common/AIRPNumberInput/AIRPNumberInput';

interface OtherUnitsWizardProps {
    apartmentStyles: Record<string, unknown>[];
    multiresRowHouseUnitSubtype: Record<string, unknown>[];
    apartmentNumber: Record<string, unknown>;
    updateApartmentNumber: (value: number | null, name: string) => void;
    aptTypeMap: Record<string, string[]>;
    apartmentStyleArray: Record<string, unknown>;
}

export default function OtherUnitsWizard(props: OtherUnitsWizardProps): JSX.Element {
    const { t } = useTranslation("guided_wizard");
    console.log(props.apartmentStyleArray)
    return (<div>
        <p>{t("other-units-wizard.other-units-description")}</p>
        <table className='wizard-table' role='presentation'>
            <thead>
                <tr><th colSpan={props.multiresRowHouseUnitSubtype.length + 1} scope="colgroup">{t("apartment-headings.suite-type")}</th></tr>
                <tr>
                    <th key={`other-units-header`}>{t("apartment-headings.style")}</th>
                    {props.multiresRowHouseUnitSubtype.map((subtype, index) => {
                        return <th key={`other-units-header-${index}`}>
                            <label htmlFor={`other-units-${props.apartmentStyles[0]["unitStyleCode"]}-${subtype["unitSubtypeCode"]}`}>
                                {subtype.unitSubtypeDescription as string}
                            </label>
                        </th>
                    })}
                </tr>
            </thead>
            <tbody>
                {props.apartmentStyles.filter((apartmentStyle) => (apartmentStyle["unitStyleCode"] !== "1" && props.apartmentStyleArray[apartmentStyle["unitStyleCode"] as string])).map((apartmentStyle, i) =>(
                <tr key={`other-units-row-${i}`}>
                    <td key={`other-units-row-${i}-0`}>{apartmentStyle["unitStyleDescription"] as string}</td>
                    {props.multiresRowHouseUnitSubtype.map((subtype, index) => {
                        return <td key={`other-units-row-${i}-${index + 1}`}>
                            <AIRPNumberInput
                                negatives={false}
                                decimals={false}
                                max={999}
                                initialValue={((props.apartmentNumber[apartmentStyle["unitStyleCode"] as string] as Record<string, unknown>)[subtype["unitSubtypeCode"] as string] as number).toString()}
                                name={`other-units-${apartmentStyle["unitStyleCode"]}-${subtype["unitSubtypeCode"]}`}
                                onChange={(value: number | null) => props.updateApartmentNumber(value, `other-units-${apartmentStyle["unitStyleCode"]}-${subtype["unitSubtypeCode"]}`)}

                            />
                        </td>
                    })}
                </tr>
                ))}
            </tbody>
        </table>
    </div>)
}